import { Injectable } from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {AuthService} from '@app/+auth/shared/services/auth.service';
import {environment} from '@environments/environment';
import {GenericHttpService} from '@core/services';

@Injectable({
  providedIn: 'root'
})
export class PartnerService extends GenericHttpService<any> {

  constructor(
    httpClient: HttpClient
  ) {
    super(httpClient, environment.apiUrl, 'partner');
  }

  // Get Partner Information from partner id
  getPartnerInformationById() {
    return super.get('getPartnerInformationByPartnerUserId');
  }

  // Get Partner Information with their lead therapists from partner id
  getPartnerAndAssignedTherapistsInformation() {
    return super.get('getAllLeadTherapistsInformationByPartnerUserId');
  }

  // Get All Gaba Plans Informationfrom partner id
  getAllGabaPlansInformation() {
    return super.get('getAllGabaPlansInformationByPartnerUserId');
  }

  // Get Selected Gaba Plan Information from partner id
  getSelectedGabaPlanInformation(gabaPlanId) {
    return super.get('getSelectedPartnerGabaPlanInformation/' + gabaPlanId);
  }

  // Load all area of focus
  getAreasOfFocus() {
    return super.get('getAllAreaOfFocusDetails');
  }

  // Update partner personal information
  updatePartnerInformation(partnerPersonalInformation) {
    return super.post(partnerPersonalInformation, 'updatePartnerPersonalInformation');
  }


  // Update new password
  updateNewPassword(passwordData){
    super.endpoint = 'partner';
    return super.post(passwordData, 'update-password');
  }

  // Update Service Agreement
  updateServiceAgreementAcknowledged(serviceAgreementAcknowledged){
    super.endpoint = 'partner';
    return super.post( serviceAgreementAcknowledged, 'partner-information/serviceAgreementAcknowledged');
  }

  // Get user information by id
  getUserInformationById(userId) {
    super.endpoint = 'partner';
    return super.get('getUserInformation/' + userId);
  }

  // Get user information by id
  downloadGabaPlanInformation(gabaPlanData) {
    super.endpoint = 'partner';
    return super.postBlob(gabaPlanData, 'generate-pdf');
  }

}
